export interface GeneralReportEnabledField {
    masterCompanyCode: boolean,
    companyCode: boolean,
    customerCode: boolean,
    activeInd: boolean,
    criteriaType: boolean,
    criteriaName: boolean,
    docNo: boolean,
    docDate: boolean,
    opsDate: boolean,
    proposalNo: boolean,
    effectiveDate: boolean,
    expiryDate: boolean,
    glDate: boolean,
    chargeOnCompany: boolean,
    yearInput: boolean,
    month: boolean,
    exceptionType: boolean,
    ediView: boolean,
    chargeType: boolean,
    monthlyRevenueCheckBox: boolean,
    //billingClerk: boolean,
    date: boolean,
    proposalType: boolean,
    proposalStatus: boolean,
    version: boolean,
    proposalFromTo: boolean,
    tariff: boolean,

    vesselArrivalDate: boolean,
    thc: boolean,
    shipmentType: boolean,
    containerSize: boolean,
    containerStatus: boolean,
    type: boolean,
    opsLine: boolean,
    download: boolean,
    consortiumCode: boolean,
    vessleCode: boolean,
    voyageCode: boolean,
    billToCompany: boolean,
    companyType: boolean,
    companyName: boolean,
    ntnNo: boolean,
    amount: boolean,
    transactionType: boolean,
    transactionDate: boolean,
    depositAmount: boolean,
    userId: boolean,
    shipperConsignee: boolean,
    shipperConsigneeCompanyName: boolean,
    subType: boolean,
    docType: boolean,
    view: boolean,
    masterChargeOnCompany: boolean,
    operatingTml: boolean,
    serviceCode: boolean,
    referenceDate: boolean,
    approvedDate: boolean,
    //AQCT/OICT/RSCT
    settlementDate: boolean,
    collDate: boolean,
    cashier: boolean,
    shippingLine: boolean,
    tariffCode: boolean,
    lpaCompanyCode: boolean,
    dateTimeFromTo: boolean,
}

export const DEFAULT_ENABLED_GENERAL_REPORT_FIELD: GeneralReportEnabledField = {
    masterCompanyCode: false,
    companyCode: false,
    customerCode: false,
    activeInd: false,
    criteriaType: false,
    criteriaName: false,
    docNo: false,
    docDate: false,
    opsDate: false,
    proposalNo: false,
    effectiveDate: false,
    expiryDate: false,
    glDate: false,
    chargeOnCompany: false,
    yearInput: false,
    month: false,
    exceptionType: false,
    ediView: false,
    chargeType: false,
    monthlyRevenueCheckBox: false,
    //billingClerk: false,
    date: false,
    proposalType: false,
    proposalStatus: false,
    version: false,
    proposalFromTo: false,
    tariff: false,
    type: false,
    opsLine: false,
    download: false,
    consortiumCode: false,
    vessleCode: false,
    voyageCode: false,
    billToCompany: false,
    companyType: false,
    companyName: false,
    ntnNo: false,
    amount: false,
    transactionType: false,
    transactionDate: false,
    depositAmount: false,
    userId: false,
    shipperConsignee: false,
    shipperConsigneeCompanyName: false,
    subType: false,
    docType: false,
    view: false,
    masterChargeOnCompany: false,
    operatingTml: false,
    serviceCode: false,
    referenceDate: false,
    approvedDate: false,
    thc: false,
    shipmentType: false,
    containerSize: false,
    containerStatus: false,
    vesselArrivalDate: false,
    //AQCT/OICT/RSCT
    lpaCompanyCode: false,
    settlementDate: false,
    collDate: false,
    cashier: false,
    shippingLine: false,
    tariffCode: false,
    dateTimeFromTo: false,
}